import { render, staticRenderFns } from "./IngDetails.vue?vue&type=template&id=445e51b8&scoped=true&"
import script from "./IngDetails.vue?vue&type=script&lang=js&"
export * from "./IngDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e51b8",
  null
  
)

export default component.exports